module.exports = __webpack_public_path__ + "static/media/graphite.e2ca2409.png";